import minutesToDurationString from "../../../utils/converters/minutes-to-duration-string"
import { TApiTaskDetails } from "../../api-client/types"

export function formatTaskDurationWithEstimate(task: TApiTaskDetails) {
  const isAboveEstimate = !!(task.timeEstimateDuration && task.timeEstimateDuration != 0 && task.worktime && task.timeEstimateDuration < task.worktime)
  const durationString = minutesToDurationString(task.worktime || 0) 
  const estimateString = (task.timeEstimateDuration && task.timeEstimateDuration != 0) ? `of ${minutesToDurationString(task.timeEstimateDuration)}` : ''

  return `${durationString} ${estimateString}`
}